export const formatResultCurrency = (value: number): string =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);

export const formatResultSignedCurrency = (value: number): string =>
  `+${formatResultCurrency(value)}`;

export const formatResultCompactCurrency = (value: number): string => {
  const abs = Math.abs(value);
  if (abs >= 1_000_000) {
    return `$${(abs / 1_000_000).toFixed(1)}M`;
  }
  if (abs >= 1_000) {
    return `$${Math.round(abs / 1_000)}k`;
  }
  return formatResultCurrency(abs);
};

export const formatResultSignedCompactCurrency = (value: number): string =>
  `+${formatResultCompactCurrency(value)}`;
